module.exports = __webpack_public_path__ + "static/media/oneNote_ex.5e667368.png";